import {BASE_AUDIT_API, fetchAPI} from '@/services/api';

export interface AuditProgramSectionVO {
    client?: string;
    yearEnd?: string;
    fileNo?: string;
    preparedBy?: string;
    preparedInitial?: string;
    reviewedBy?: string;
    reviewedInitial?: string;
    partnerName?: string;
    /** First company director — A1.2 H10 "Enquired with …" */
    enquiryDirectorName?: string;
    pages?: Record<string, Record<string, unknown>>;
}

export interface AuditProgramSectionSavePayload {
    companyId: number;
    annualId: number;
    sectionCode: string;
    pageCode: string;
    fieldData: Record<string, unknown>;
}

const base = `${BASE_AUDIT_API}/audit-program/section`;

export async function getAuditProgramSection(
    companyId: number,
    annualId: number,
    sectionCode: string,
    pageCode?: string,
): Promise<AuditProgramSectionVO> {
    const qs = new URLSearchParams({
        companyId: String(companyId),
        annualId: String(annualId),
        sectionCode,
    });
    if (pageCode) qs.set('pageCode', pageCode);
    return fetchAPI<AuditProgramSectionVO>(`${base}/get?${qs.toString()}`);
}

export async function saveAuditProgramSectionPage(payload: AuditProgramSectionSavePayload): Promise<boolean> {
    return fetchAPI<boolean>(`${base}/save`, {
        method: 'POST',
        body: JSON.stringify(payload),
    });
}

export async function getASectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'A');
}

export async function saveASectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'A', pageCode, fieldData});
}

export async function getBSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'B');
}

export async function saveBSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'B', pageCode, fieldData});
}

export async function getCSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'C');
}

export async function saveCSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'C', pageCode, fieldData});
}

export async function getDSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'D');
}

export async function saveDSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'D', pageCode, fieldData});
}

export async function getESectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'E');
}

export async function saveESectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'E', pageCode, fieldData});
}

export async function getFSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'F');
}

export async function saveFSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'F', pageCode, fieldData});
}

export async function getHSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'H');
}

export async function saveHSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'H', pageCode, fieldData});
}

export async function getGSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'G');
}

export async function saveGSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'G', pageCode, fieldData});
}

export async function getISectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'I');
}

export async function saveISectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'I', pageCode, fieldData});
}

export async function getJSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'J');
}

export async function saveJSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'J', pageCode, fieldData});
}

export async function getKSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'K');
}

export async function saveKSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'K', pageCode, fieldData});
}

export async function getLSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'L');
}

export async function saveLSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'L', pageCode, fieldData});
}

export async function getMSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'M');
}

export async function saveMSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'M', pageCode, fieldData});
}

export async function getNSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'N');
}

export async function saveNSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'N', pageCode, fieldData});
}

export async function getOSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'O');
}

export async function saveOSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'O', pageCode, fieldData});
}

export async function getPSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'P');
}

export async function savePSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'P', pageCode, fieldData});
}

export async function getQSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'Q');
}

export async function saveQSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'Q', pageCode, fieldData});
}

export async function getRSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'R');
}

export async function saveRSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'R', pageCode, fieldData});
}

export async function getSSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'S');
}

export async function saveSSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'S', pageCode, fieldData});
}

export async function getTSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'T');
}

export async function saveTSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'T', pageCode, fieldData});
}

export async function getWSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'W');
}

export async function saveWSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'W', pageCode, fieldData});
}

export async function getVSectionVO(companyId: number, annualId: number): Promise<AuditProgramSectionVO> {
    return getAuditProgramSection(companyId, annualId, 'V');
}

export async function saveVSectionPage(
    companyId: number,
    annualId: number,
    pageCode: string,
    fieldData: Record<string, unknown>,
): Promise<boolean> {
    return saveAuditProgramSectionPage({companyId, annualId, sectionCode: 'V', pageCode, fieldData});
}
